__turbopack_context__.v({
  "bordered": "LinkList-module__kdz27a__bordered",
  "capitalized": "LinkList-module__kdz27a__capitalized",
  "item": "LinkList-module__kdz27a__item",
  "itemBordered": "LinkList-module__kdz27a__itemBordered",
  "linkGroup": "LinkList-module__kdz27a__linkGroup",
  "list": "LinkList-module__kdz27a__list",
});
